<template>
  <setting></setting>
</template>

<script>
import setting from './setting.vue'
export default {
  components: {
    setting
  }
}
</script>

<style>
</style>